<template>
    <button :title="label" :class="[buttonClass, fitInlineClass, sizeClass, { 'btn-disabled': isDisabled }, {'btn-block': displayBlock}]" :disabled="isDisabled" @click="handleClick">
        <span v-if="!!icon && (!iconAlignment || iconAlignment === 'left')">
            <font-awesome-icon class="cta-icon-left" :icon="icon" :class="{ 'cta-icon-no-padding': noIconPadding }"></font-awesome-icon>
        </span>
        <span v-if="label" :class="[`cta-label`, {'cta-label-large': largeLabelAtMobile }]" ><template v-if="!useLabelAsTitleOnly">{{ label }}</template></span>
        <span v-if="!!icon && iconAlignment === 'right'">
            <font-awesome-icon class="cta-icon-right" :icon="icon" :class="{ 'cta-icon-no-padding': noIconPadding }"></font-awesome-icon>
        </span>
    </button>
</template>

<script lang="ts">
export default {
    name: 'CTA',
    props: {
        type: {
            type: String,
            required: true,
            validator: (value: string) => ['link', 'primary', 'outline', 'secondary'].includes(value),
            default: 'primary',
        },
        size: {
            type: String,
            default: '',
            validator: (value: string) => ['sm', 'lg'].includes(value),
        },
        fitInline: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        route: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
	    useLabelAsTitleOnly: {
		    type: Boolean,
		    default: false
	    },
        icon: {
            type: Array,
            default: [],
        },
        titleAttr: {
            type: String,
            default: ''
        },
        iconAlignment: {
            type: String,
            default: 'left',
            validator: (value: string) => ['left', 'right'].includes(value),
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
	    isHidden: {
			type: Boolean,
		    default: false,
	    },
        noIconPadding: {
            type: Boolean,
            default: false,
        },
	    displayBlock: {
			type: Boolean,
		    default: false
	    },
	    largeLabelAtMobile: {
			type: Boolean,
		    default: false
	    }
    },
    computed: {
        buttonClass() {
            switch (this.type) {
                case 'link':
                    return 'btn btn-link-underline';
                case 'outline':
                    return `btn btn-outline-primary`;
                case 'primary':
                    return 'btn btn-primary';
                case 'secondary':
                    return 'btn btn-secondary-basic';
                default:
                    return '';
            }
        },
        sizeClass() {
            return this.size === 'sm' ? 'btn-sm' : this.size === 'lg' ? 'btn-lg' : '';
        },
        fitInlineClass() {
            return this.fitInline ? 'fit-inline' : null;
        },
    },
    methods: {
        handleClick() {
            if (this.route) {
                this.$emit('updateRoute', this.route);
            } else {
                this.$emit('onClick');
            }
        },
    },
};
</script>
